/** Notas fiscais: envio, leitura, vínculo com a despesa e filtros. */

import { api } from './client';
import type { DespesaDaNota, ListaDeNotas, NotaDetalhe } from '../types';

export interface FiltrosDeNotas {
  /** aaaa-mm; vazio = todos os meses. */
  mes?: string;
  status?: string;
  tipo?: string;
  vinculo?: 'com' | 'sem' | '';
  busca?: string;
}

export interface EdicaoDeNota {
  fornecedor?: string;
  cnpj?: string | null;
  numero?: string | null;
  descricao?: string | null;
  valor?: string;
  data_documento?: string | null;
  tipo_documento?: string;
  status?: string;
  observacao?: string | null;
  /** `null` desfaz o vínculo. */
  lancamento_id?: number | null;
}

const semVazios = (filtros: FiltrosDeNotas) =>
  Object.fromEntries(Object.entries(filtros).filter(([, v]) => v !== undefined && v !== ''));

export const ApiNotas = {
  listar: async (filtros: FiltrosDeNotas) =>
    (await api.get<ListaDeNotas>('/notas-fiscais', { params: semVazios(filtros) })).data,
  obter: async (id: number) => (await api.get<NotaDetalhe>(`/notas-fiscais/${id}`)).data,
  procurarDespesas: async (id: number, busca: string) =>
    (await api.get<DespesaDaNota[]>(`/notas-fiscais/${id}/despesas`, { params: busca ? { busca } : {} })).data,

  /** Uma nota por chamada; PDF e foto passam pela leitura da IA. */
  enviar: async (arquivo: File, aoProgredir?: (fracao: number) => void) => {
    const corpo = new FormData();
    corpo.append('arquivo', arquivo);
    return (
      await api.post<NotaDetalhe>('/notas-fiscais', corpo, {
        timeout: 300_000,
        onUploadProgress: (e) => {
          if (aoProgredir && e.total) aoProgredir(Math.min(1, e.loaded / e.total));
        },
      })
    ).data;
  },
  editar: async (id: number, dados: EdicaoDeNota) =>
    (await api.patch<NotaDetalhe>(`/notas-fiscais/${id}`, dados)).data,
  excluir: async (id: number): Promise<void> => {
    await api.delete(`/notas-fiscais/${id}`);
  },
  arquivo: async (id: number, baixar = false): Promise<Blob> =>
    (await api.get<Blob>(`/notas-fiscais/${id}/arquivo`, { params: baixar ? { baixar: true } : {}, responseType: 'blob', timeout: 120_000 })).data,
};

export const endpointDaNota = (id: number) => `/notas-fiscais/${id}/arquivo`;
